import { CampaignVisibilityFilter } from "@intentsify/dto";
import {
  BusinessUnit,
  CampaignForList,
  SortDirection,
} from "@intentsify/types";
import { FetchDataParams, FetchDataParamsWithToken } from "types";

export type ListPaginatedCampaignsParams = FetchDataParamsWithToken<
  keyof CampaignForList
> & {
  isFavorite: boolean;
  includeCampaignsInDraft?: boolean;
};

export const defaultListPaginatedCampaignsParams: ListPaginatedCampaignsParams =
  {
    isFavorite: false,
    includeCampaignsInDraft: false,
    pageToken: undefined,
    search: undefined,
    order_by: "campaignId",
    order: SortDirection.DESC,
  };

export type CampaignsAdminFilters = {
  createdByIds: number[];
  companyIds: number[];
  visibility?: CampaignVisibilityFilter;
  createdFrom?: string;
  createdTo?: string;
};

export const emptyCampaignsAdminFilters: CampaignsAdminFilters = {
  createdByIds: [],
  companyIds: [],
  visibility: undefined,
  createdFrom: undefined,
  createdTo: undefined,
};

export type CampaignsTableFiltersState = CampaignsAdminFilters & {
  isFavorite: boolean;
  onlyDrafts: boolean;
};

export const emptyCampaignsTableFilters: CampaignsTableFiltersState = {
  isFavorite: false,
  onlyDrafts: false,
  ...emptyCampaignsAdminFilters,
};

export type ListCampaignsPageParams = FetchDataParams<keyof CampaignForList> &
  CampaignsTableFiltersState;

export const defaultListCampaignsPageParams: ListCampaignsPageParams = {
  page: 1,
  per_page: 10,
  search: undefined,
  order_by: "campaignId",
  order: SortDirection.DESC,
  ...emptyCampaignsTableFilters,
};

export type CompanyBusinessUnitsFetchDataParams = FetchDataParamsWithToken<
  keyof BusinessUnit
>;

export const defaultListPaginatedCompanyBusinessUnitsParams: CompanyBusinessUnitsFetchDataParams =
  {
    search: undefined,
    order_by: "displayName",
    order: SortDirection.ASC,
    pageToken: "",
  };
